<template>
  <div class="common-footer">
    <span class="common-footer_text">
      儲值咨詢：<a v-datain="{ext3: '客服工单-按钮'}" class="common-footer_link j-show-service" href="https://service.gm99.com/#/" target="_blank">客服工單 &gt;</a>
    </span>
    <span class="common-footer_text" v-show="false">
      <span class="common-footer_tel">客服電話：<span class="common-footer_tel-em j-phone-code">02-23560356</span></span>
      <span class="common-footer_time">周一至五09:00-17:00</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'commonFooter'
}
</script>

<style lang="scss" scoped>
.common-footer{
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: left;
  background-color: #f5f5f3;
  &_text {
    width: 49%;
    color: #aaa;
    font-size: 11px;
    line-height: 1.5;
    text-align: left;
    display: inline-block;
    vertical-align: middle;
    &:last-of-type {
      text-align: right;
      width: 50%;
      border-left: 1px solid #dcdcda;
    }
  }
  &_link {
    font-size: 15px;
    color: #01bbfe;
    text-decoration: none;
  }
  &_tel-em {
    font-size: 15px;
    color: #01bbfe;
    text-align: left;
  }
  &_time {
    display: block;
  }
}
</style>
